import {Component, Input} from '@angular/core';
import {AjaxService} from 'AjaxService';

@Component({
  selector: 'cz-antrag-be-veraenderung-aenderungen-popup',
  templateUrl: './antrag-be-veraenderung-aenderungen-popup.component.html',
  styleUrls: ['./antrag-be-veraenderung-aenderungen-popup.component.css'],
  standalone: false,
})
export class AntragBeVeraenderungAenderungenPopupComponent {
  @Input() antragBeId: number;

  popupVisible = false;
  loading = false;
  errorMessage = '';
  data: any = {ues: []};
  private readonly openSections = new Set<string>();

  constructor(private ajaxService: AjaxService) {
    this.hidePopup = this.hidePopup.bind(this);
  }

  showPopup(): void {
    this.popupVisible = true;
    this.load();
  }

  hidePopup(): void {
    this.popupVisible = false;
  }

  toggle(section: string): void {
    if (this.openSections.has(section)) {
      this.openSections.delete(section);
      return;
    }

    this.openSections.add(section);
  }

  isOpen(section: string): boolean {
    return this.openSections.has(section);
  }

  getHeCount(he: any): number {
    if (!he) {
      return 0;
    }

    return this.getKonzeptionCount(he.konzeption)
      + (he.anhaenge || []).reduce((count, anhang) => count + this.getEntryCount(anhang), 0);
  }

  getUeCount(ue: any): number {
    if (!ue) {
      return 0;
    }

    return (ue.stamm || []).length
      + this.getKonzeptionCount(ue.konzeption)
      + (ue.personal || []).reduce((count, personal) => count + this.getEntryCount(personal), 0);
  }

  getKonzeptionCount(konzeption: any): number {
    return this.getEntryCount(konzeption);
  }

  getEntryCount(entry: any): number {
    if (!entry) {
      return 0;
    }

    return (entry.items || []).length + (entry.documents || []).length + (entry.status ? 1 : 0);
  }

  private load(): void {
    this.loading = true;
    this.errorMessage = '';
    this.data = {ues: []};
    this.openSections.clear();

    this.ajaxService.post<any>('api/ExternAntragBeVeraenderung/GetAenderungen', {
      antragBeId: this.antragBeId,
    }).subscribe({
      next: (response) => {
        this.data = response || {ues: []};
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Die Änderungen konnten nicht geladen werden.';
        this.loading = false;
      },
    });
  }
}